module.exports = __webpack_public_path__ + "static/media/applePay.2d868d87.png";